<template>
  <VaLayout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-secondary)]">
    <template #left>
      <div class="bg-primary h-full flex items-center justify-center" style="width: 35vw">
        <a href="https://spend-fit.com/">
          <VuesticLogo />
        </a>
      </div>
    </template>
    <template #content>
      <main class="h-full flex items-center justify-center mx-auto max-w-[420px]">
        <RouterView />
      </main>
    </template>
  </VaLayout>

  <VaLayout v-else class="h-screen bg-[var(--va-background-secondary)]">
    <template #content>
      <div class="p-4">
        <main class="h-full flex flex-row items-center justify-start mx-auto max-w-[420px]">
          <div class="flex flex-col items-start">
            <div class="bg-primary w-full py-4 mb-3 logo">
              <VuesticLogo />
            </div>
            <RouterView />
          </div>
        </main>
      </div>
    </template>
  </VaLayout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui'
import VuesticLogo from '../components/VuesticLogoLogin.vue'

const breakpoint = useBreakpoint()
</script>
<style lang="scss" scoped>
.logo {
  padding-left: 20%;
}
</style>
